  <h4 style="text-align: center;">Print Assessment Appeals Agenda</h4>
  <h6 style="text-align: center;"><b>View the current agenda of the Assessment Appeals Board using the links below.</b></h6>
  <br />
  <div class="row">
    <div class="col-md-6 offset-md-3">
      <button class="btn btn-sm btn-link" title="Return to main menu" (click)="goHome()">Return to Menu</button>
    </div>
  </div>
  <div class="row" *ngIf='displayState.workingDiv'>
    <div class="col-md-6 offset-md-3">
      <div class="card">
        <br />
        <div class="card-body">
          <div class="row" style="margin: 10px;" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<div class="row" style="margin: 10px;" *ngIf='displayState.gridDiv'>
  <br />
  <div class="col-md-6 offset-md-3">
    <div class="card">
      <div class="card-body" style="background-color:#e9ecef">
        <table class="table table-striped">
          <thead>
          <tr>
            <th *ngFor="let col of cols; let i = index">
              {{col.header}}
            </th>
            <th></th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let hearing of hearingList; let i = index">
              <td>{{ hearing.hearingDate | date:"MM/dd/yyyy"}}</td>
              <td>{{ hearing.hearingTime }}</td>
              <td><button class="btn btn-link" (click)="onSelect(hearing)"> View </button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
